import { useMutation } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export function useUpdateSession() {
  return useMutation(trpcOptions.app.updateSession.mutationOptions())
}
